module.exports = __webpack_public_path__ + "img/logo.f38a8a69.png";